package games.polyclub.website.frontend.store.layout

import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.tags.*
import games.polyclub.frontend.lib.react.utils.classSet
import games.polyclub.website.frontend.store.hooks.useUserPreferences
import react.Props

external interface TopBarProps : Props {

}

val TopBar = SFC<TopBarProps> { _ ->
    val userPrefsCtx = useUserPreferences()
    nav("main-header navbar navbar-expand") {
        if (userPrefsCtx.preferences.darkMode) {
            classSet += "navbar-dark"
        } else {
            classSet += "navbar-white"
            classSet += "navbar-light"
        }
        TopBarLinks()
        TopRightBar()
    }
}
